import { jwtDecode } from "jwt-decode";

interface JWTPayload {
  openid?: string;
  uuid?: string;
  user_id?: number | string;
  iss?: string;
  exp?: number;
  iat?: number;
}

const getTokenIdentity = (decoded: JWTPayload): string | null => {
  if (decoded.openid) {
    return decoded.openid;
  }

  if (decoded.uuid) {
    return decoded.uuid;
  }

  if (decoded.user_id !== undefined && decoded.user_id !== null) {
    return String(decoded.user_id);
  }

  return null;
};

export const checkToken = (token: string | null): boolean => {
  if (!token) return false;

  try {
    const decoded = jwtDecode<JWTPayload>(token);
    const currentTime = Math.floor(Date.now() / 1000);

    if (typeof decoded.exp !== "number") {
      return false;
    }

    // 验证令牌是否过期
    if (decoded.exp < currentTime) {
      return false;
    }

    // 兼容旧 token 的发行者校验，同时接受 v3 不带 iss 的 token
    if (decoded.iss && decoded.iss !== "HongMoAI") {
      return false;
    }

    return !!getTokenIdentity(decoded);
  } catch (error) {
    return false;
  }
};

export const getOpenId = (token: string | null): string | null => {
  if (!token) return null;

  try {
    const decoded = jwtDecode<JWTPayload>(token);
    return getTokenIdentity(decoded);
  } catch (error) {
    return null;
  }
};

export const persistToken = (
  token: string,
  setToken: (token: string | null) => void
) => {
  localStorage.setItem("jwt_token", token);
  setToken(token);
};

// 添加退出登录函数
export const logout = (setToken: (token: string | null) => void) => {
  // 清除token
  setToken(null);

  // 清除所有与登录相关的存储
  localStorage.removeItem("jwt_token");
  localStorage.removeItem("user_data");
  
  // 清除邀请相关数据
  localStorage.removeItem("inviteId");
  
  // 清除会话存储
  sessionStorage.removeItem("redirectAfterLogin");
  sessionStorage.clear();
  
  // 清除所有设置了过期时间的本地存储
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
          key.includes("token") || 
          key.includes("user") || 
          key.includes("auth") ||
          key.includes("login") ||
          key.includes("session")
        )) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
  } catch (e) {
    console.error("清除本地存储时出错:", e);
  }
  
  // 跳转到登录页
  window.location.href = "/console/login";
};
